export const typeRoutes = {
	types: (query: string) => `/product-types/${query ? `?${query}` : ''}`,
	type: (id: string) => `/product-types/${id}/`,
	typesDelete: '/product-types/bulk_delete/'
} as const
